<div *ngIf="user" class="tw-w-full tw-h-full tw-min-h-[100vh] tw-max-h-[100vh] tw-flex tw-flex-col tw-overflow-auto tw-p-5">
  <app-menu-mobile></app-menu-mobile>
  <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xl tw-text-secondary tw-mb-5">{{ "analytics" | translate }}</p>
  <div class="tw-w-full tw-h-fit tw-flex max-md:tw-justify-end tw-flex-wrap-reverse md:tw-flex-wrap tw-gap-4 tw-mb-5">
    <div class="tw-w-full md:tw-max-w-72 tw-h-12 tw-relative tw-flex tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-auto tw-px-4 tw-py-3">
      <input
        #searchInput
        class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-bg-transparent tw-text-secondary tw-outline-none tw-pr-8"
        [(ngModel)]="search"
        (change)="setSearch($event)"
        [placeholder]="'search-here' | translate"
      />
      <img class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" src="../../../assets/search-icon.svg" />
    </div>
    <p-dropdown
      class="tw-border tw-border-grey-600 tw-rounded-[5px]"
      [options]="branches"
      [(ngModel)]="selectedBranch"
      optionLabel="name"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      [placeholder]="'select-branch' | translate"
      (onFilter)="searchBranches.next($event.filter)"
      [emptyFilterMessage]="searchBranchNoResults | translate"
      (onChange)="setBranch($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.name }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <p-dropdown
      class="tw-border tw-border-grey-600 tw-rounded-[5px]"
      [options]="riders1"
      [(ngModel)]="selectedRider"
      optionLabel="fullName"
      [filter]="true"
      filterBy="fullName"
      [showClear]="true"
      [placeholder]="'assigned-to' | translate"
      (onFilter)="searchRiders1.next($event.filter)"
      [emptyFilterMessage]="searchRider1NoResults | translate"
      (onChange)="setAssignedTo($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.fullName }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.fullName }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <p-dropdown
      *ngIf="user.user.business.type == accountTypes.Merchant"
      class="tw-border tw-border-grey-600 tw-rounded-[5px]"
      [options]="thirdParties"
      [(ngModel)]="selectedThirdParty"
      optionLabel="name"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      [placeholder]="'3rd-party' | translate"
      (onFilter)="searchThirdParties.next($event.filter)"
      [emptyFilterMessage]="searchThirdPartiesNoResults | translate"
      (onChange)="setThirdParty($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.name }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <input
      class="tw-w-fit tw-max-w-72 tw-h-12 tw-relative tw-flex tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-auto tw-px-4 tw-py-3"
      type="datetime-local"
      [(ngModel)]="startDate"
      (change)="onDateChange()"
    />
    <input
      class="tw-w-fit tw-max-w-72 tw-h-12 tw-relative tw-flex tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-auto tw-px-4 tw-py-3"
      type="datetime-local"
      [(ngModel)]="endDate"
      (change)="onDateChange()"
    />
  </div>

  <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-4">
    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex-1 tw-flex max-md:tw-flex-col tw-gap-4">
          <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex-1 tw-bg-white tw-rounded-[5px] tw-border tw-border-grey-600 tw-p-4">
              <p class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary">{{ "total-orders" | translate }}</p>
              <p class="tw-text-2xl tw-font-bold tw-text-secondary">{{ totalOrders }}</p>
            </div>

            <div class="tw-flex-1 tw-bg-white tw-rounded-[5px] tw-border tw-border-grey-600 tw-p-4">
              <p class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary">{{ "total-revenue" | translate }}</p>
              <p class="tw-text-2xl tw-font-bold tw-text-secondary">{{ totalMoney | mycurrency }}</p>
            </div>
          </div>
          <div class="tw-flex-1 tw-bg-white tw-rounded-[5px] tw-border tw-border-grey-600 tw-p-4">
            <p class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary">{{ "top-categories" | translate }}</p>
            <div *ngIf="topCategories.length === 0" class="tw-flex tw-justify-center tw-items-center tw-h-20">
              <p class="tw-text-gray-500">{{ "no-data-available" | translate }}</p>
            </div>
            <ul *ngIf="topCategories.length > 0" class="tw-divide-y">
              <li *ngFor="let category of topCategories; let i = index" class="tw-py-2 tw-flex tw-justify-between tw-items-center">
                <div class="tw-flex tw-items-center">
                  <span class="tw-w-6 tw-h-6 tw-bg-grey-600 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-mr-2">{{ i + 1 }}</span>
                  <span class="tw-font-medium">{{ category.category }}</span>
                </div>
                <span class="tw-text-gray-600">{{ category.totalQuantitySold }} {{ "has-been-sold" | translate }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="tw-flex-1 tw-min-h-96 tw-max-h-96 tw-relative tw-overflow-hidden tw-rounded-[5px]">
          <div id="map" class="tw-w-full tw-h-full"></div>
          <div *ngIf="isLoading" class="tw-absolute tw-inset-0 tw-bg-white/70 tw-flex tw-justify-center tw-items-center">
            <p class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "loading" | translate }}</p>
          </div>
        </div>
      </div>

      <div class="tw-flex-1 tw-bg-white tw-rounded-[5px] tw-border tw-border-grey-600 tw-p-4">
        <p class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary">{{ "top-products-in-map" | translate }}</p>
        <div *ngIf="topProducts.length === 0" class="tw-flex tw-justify-center tw-items-center tw-h-20">
          <p class="tw-text-gray-500">{{ "no-data-available" | translate }}</p>
        </div>
        <ul *ngIf="topProducts.length > 0" class="tw-divide-y">
          <li *ngFor="let product of topProducts; let i = index" class="tw-py-2 tw-flex tw-justify-between tw-items-center">
            <div class="tw-flex tw-items-center">
              <span class="tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-mr-2" [style.background-color]="product.color">{{ i + 1 }}</span>
              <span class="tw-font-medium">{{ product.productName }}</span>
            </div>
            <span class="tw-text-gray-600">{{ product.totalQuantitySold }} {{ "has-been-sold" | translate }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="tw-w-full tw-h-6"></div>
</div>
